

<div class="container-fluid dashboard-topbard">
    <div class="row">
        <div class="col-lg-2 col-sm-2">
            <div class="dashboard-logo mt-2 white-text pb-2"><strong> Admin Panel </strong> </div>
        </div>
        <div class="col-lg-10 col-sm-10">
            <ul class="topbar-menu float-right mt-2 white-text">
                <li><img src=""> Welcome to Admin Panel</li>
                <li class="ml-2 mr-2"><img src=""> | </li>
                <li class="dashboard-dropdown-link"><a href="#">My Account</a>
                    
                    <ul class="dashboard-dropdown">
                        <li><a href="#">Profile</a></li>
                        <li><a href="#">Change Password</a></li>
                    </ul>

                </li>

            </ul>
        </div>
    </div>
</div>

<div class="dashboard-full-width">
    
            <div class="main-container-dashboard">


                
                    <aside class="sidebard-bg">
                        <ul class="dashboard-asidebar">
                            <li><a href="#"><i class="fas fa-tachometer-alt"></i> Dashboard</a></li>
                            <li><a href="#"><i class="fas fa-list-ul"></i> Report</a></li>
                            <li><a href="#"><i class="far fa-calendar-check"></i> Form</a></li>
                            
                        </ul> 
                    </aside>
                


                    <div class="dashboard-container-right">
                    
                            <div class="main-container">
                                



                                
                                <div class="row">
                                    <div class="col-12">
                                        
                                    <ul class="steps">
                                      <li class="dashboard-steps-active">Personal Information</li>
                                      <li>Book Appointment for COVID-19 Test</li>
                                      <li>Confirmation</li>
                                      <li>Pay</li>
                                    </ul>

                                    </div>
 
                                      <div class="col-lg-12">
                                        <h3 class="dashboard-heading-1">Passenger personal Information</h3>
                                        <form>
                                              <div class="row">
                                                
                                                <div class="col-md-4">
                                                  <label class="form-label">First Name</label>
                                                  <input type="email" class="form-control">
                                                </div>
                                                <div class="col-md-4">
                                                  <label  class="form-label">Middle Name</label>
                                                  <input type="text" class="form-control" >
                                                </div>
                                                <div class="col-md-4">
                                                  <label class="form-label">Last Name</label>
                                                  <input type="text" class="form-control" >
                                                </div>


                                                <div class="form-group col-md-4 mt-2">
                                                  <label for="inputState">Gender</label>
                                                  <select id="inputState" class="form-control">
                                                    <option selected="">Male</option>
                                                    <option>Female </option>
                                                  </select>
                                                </div>

                                                <div class="col-md-4 mt-2">
                                                  <label  class="form-label">Date of Birth</label>
                                                  <input type="date" class="form-control">
                                                </div>
                                                <div class="col-md-4 mt-2">
                                                  <label class="form-label">Residential Address</label>
                                                  <input type="text" class="form-control">
                                                </div>

                                                <div class="form-group col-md-4 mt-2">
                                                  <label for="inputState">Select Nationality</label>
                                                  <select id="inputState" class="form-control">
                                                    <option selected="">Nigeria</option>
                                                    <option>India </option>
                                                    <option>United Kingdom </option>
                                                  </select>
                                                </div>
                                                <div class="col-md-4 mt-2">
                                                  <label  class="form-label">Email Address</label>
                                                  <input type="email" class="form-control">
                                                </div>
                                                <div class="col-md-4 mt-2">
                                                  <label class="form-label">Confirm Email Address</label>
                                                  <input type="email" class="form-control">
                                                  <small><img src="../../../assets/image/info.png"> QR Code will be sent there</small>
                                                </div>

                                                <div class="col-md-4 mt-2">
                                                  <label class="form-label">Phone Number</label>
                                                  <input type="text" class="form-control" >
                                                </div>
                                                <div class="col-md-4 mt-2">
                                                  <label class="form-label">Occupation</label>
                                                  <input type="text" class="form-control">
                                                </div>



                                                <div class="seprator-1"></div>
                                               
                                                  
                                                  <div class="col-lg-12"><h3 class="dashboard-heading-1 minus-top-2">Passenger personal Information</h3></div>
                                                 
                                                    <div class="form-group col-md-4 mt-2">
                                                      <label for="inputState">Select Country to be visited</label>
                                                      <select id="inputState" class="form-control">
                                                        <option selected="">Male</option>
                                                        <option>Female </option>
                                                      </select>
                                                    </div>

                                                    <div class="col-md-4 mt-2">
                                                      <label class="form-label">Passport Number</label>
                                                      <input type="text" class="form-control">
                                                    </div>

                                                    <div class="col-md-4 mt-2">
                                                      <label  class="form-label">Expected Travel Date</label>
                                                      <input type="date" class="form-control">
                                                    </div>

                                                    <div class="form-group col-md-4 mt-2">
                                                      <label for="inputState">Select Airline</label>
                                                      <select id="inputState" class="form-control">
                                                        <option selected="">Option 1</option>
                                                        <option>Option 2 </option>
                                                      </select>
                                                    </div>

                                                    <div class="col-md-4 mt-2">
                                                      <label  class="form-label">Expected Travel Date</label>
                                                      <input type="date" class="form-control">
                                                    </div>


                                                    <div class="col-lg-12 mb-4 text-center"><button class="btn btn-primary">Next</button></div>
                                                 
                                                 

                                              </div>
                                        </form>

                                      </div>

                                      

                                </div>





                            </div>
                        
                    </div>

            </div>
    
</div>





